import './JsonView.css';

import { Highlight, themes } from 'prism-react-renderer';
import { useMemo } from 'react';
import clsx from 'clsx';
import { formatJson } from './utils/formatJson';

interface JsonViewProps {
  value: unknown;
  maxHeight?: string;
  minHeight?: string;
  className?: string;
}

const JsonView = ({
  value,
  maxHeight,
  minHeight,
  className,
}: JsonViewProps) => {
  const { code, invalid } = useMemo(() => formatJson(value), [value]);

  if (!code) {
    return null;
  }

  return (
    <Highlight code={code} language="json" theme={themes.vsLight}>
      {({
        className: prismClass,
        style,
        tokens,
        getLineProps,
        getTokenProps,
      }) => (
        <pre
          className={clsx(
            'json-view',
            prismClass,
            invalid && 'json-view--invalid',
            className
          )}
          style={{ ...style, maxHeight, minHeight }}
        >
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
};

export default JsonView;
